import { tramites } from "../../utils/listadoTramites";
import styles from "./titlePage.module.css";

const TitlePage = ({ idTramite }) => {
  const tramite = tramites.find((tramite) => tramite.id === idTramite);

  return (
    <>
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "row",
          gap: 10,
          alignItems: "center",
          width: "100%",
          color: tramite.color,
          fontSize: 20,
          marginBottom: "50px",
          textTransform: "uppercase",
        }}
      >
        {tramite?.icon}
        {tramite.title}
      </div>
    </>
  );
};

export default TitlePage;
